interface IPropsCpf {
  cpf: string;
  emptyCpf: string;
  incorrectCpf: string;
}
interface IPropsCnpj {
  cnpj: string;
  emptyCnpj: string;
  incorrectCnpj: string;
}

interface IReturn {
  message: string;
  status: 'Error' | '';
}

const validateCpf = ({
  cpf,
  emptyCpf,
  incorrectCpf,
}: IPropsCpf): IReturn | any => {
  if (!cpf) return { message: '', status: '' };

  const value = cpf.replace(/[^\w]/g, '');
  let Soma;
  let Resto;
  let i;
  Soma = 0;

  if (value === '00000000000' || !value)
    return {
      message: emptyCpf,
      status: 'Error',
    };

  if (
    value === '00000000000' ||
    value === '11111111111' ||
    value === '22222222222' ||
    value === '33333333333' ||
    value === '44444444444' ||
    value === '55555555555' ||
    value === '66666666666' ||
    value === '77777777777' ||
    value === '88888888888' ||
    value === '99999999999'
  ) {
    return {
      message: incorrectCpf,
      status: 'Error',
    };
  }

  for (i = 1; i <= 9; i++)
    Soma = Soma + parseInt(value.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(value.substring(9, 10)))
    return {
      message: incorrectCpf,
      status: 'Error',
    };

  Soma = 0;
  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(value.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(value.substring(10, 11)))
    return {
      message: incorrectCpf,
      status: 'Error',
    };
  return {
    message: '',
    status: '',
  };
};
const validateCnpj = ({
  cnpj,
  emptyCnpj,
  incorrectCnpj,
}: IPropsCnpj): IReturn | any => {
  if (!cnpj) return { message: '', status: '' };

  const value = cnpj.replace(/[^\w]/g, '');

  if (!value || value.length !== 14)
    return {
      message: emptyCnpj,
      status: 'Error',
    };

  if (/^(\d)\1+$/.test(value))
    return {
      message: incorrectCnpj,
      status: 'Error',
    };

  let length = value.length - 2;
  let numbers = value.substring(0, length);
  const digits = value.substring(length);
  let sum = 0;
  let pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += Number(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== Number(digits.charAt(0)))
    return {
      message: incorrectCnpj,
      status: 'Error',
    };

  length = length + 1;
  numbers = value.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += Number(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== Number(digits.charAt(1)))
    return {
      message: incorrectCnpj,
      status: 'Error',
    };

  return {
    message: '',
    status: '',
  };
};

export { validateCpf, validateCnpj };
